import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Facebook, Linkedin, Twitter, Instagram, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] border-t border-white/10 pt-16 pb-8" data-id="element-47" data-mp="32ovukn0cqfgg">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-48" data-mp="36oxzr65apr0h">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-49" data-mp="36ppjnjpj60ax">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-50" data-mp="3ud7iu0b4k0nx">
            <span className="inline-flex p-2 bg-black border border-white/80 rounded-sm" data-id="element-51" data-mp="38zaivynj750">
              <Logo className="h-24" data-id="element-52" data-mp="3levk1b03twke" />
            </span>
            <p className="text-white font-serif text-xl" data-id="element-53" data-mp="3lggb2qn7mxdi">Sinclair Develops.</p>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-54" data-mp="3qbvo5gde8p8v">
              We identify opportunities and bring together the planning, design,
              construction and management necessary to turn them into successful
              properties throughout Southwest Florida.
            </p>
            <a href="https://sinclairdevelops.com" className="inline-block text-[#C5A55A] text-sm tracking-[0.15em] uppercase hover:text-[#D4AF37] transition-colors" data-id="element-55" data-mp="3la288r748xtn">
              SinclairDevelops.com
            </a>
          </div>

          {/* Quick Links */}
          <div data-id="element-56" data-mp="3q7bvc0718xeb">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-57" data-mp="3qazr75zy9vw7">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-58" data-mp="33xe1y3atysi">
              {['Home', 'About', 'Services', 'Contact'].map(item => <li key={item} data-id="element-59" data-mp="hsk34riqa4wx">
                  <Link to={item === 'Home' ? '/' : `/${item.toLowerCase()}`} className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-60" data-mp="hriflnkizpyb">
                    {item}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-61" data-mp="tv4o84h2f862">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-62" data-mp="tvmpjfil4cku">
              What We Develop
            </h3>
            <ul className="space-y-3" data-id="element-63" data-mp="yv94bte2a0vr">
              <li className="text-gray-400 text-sm" data-id="element-64" data-mp="ys3e2atp4syg">Site Development</li>
              <li className="text-gray-400 text-sm" data-id="element-65" data-mp="13sir11a2fyfw">Commercial Development</li>
              <li className="text-gray-400 text-sm" data-id="element-66" data-mp="18k93pdwh6yah">Residential Development</li>
              <li className="text-gray-400 text-sm" data-id="element-67" data-mp="1clun7i3imatn">Redevelopment</li>
              <li className="text-gray-400 text-sm" data-id="element-68" data-mp="1cnoz66wt6sll">Tenant Improvements</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-69" data-mp="1mj8w8wn3zxbx">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-70" data-mp="1mktqel5ihe99">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-71" data-mp="1rhk5p69hs5tm">
              <li className="flex items-start gap-3 text-gray-400 text-sm" data-id="element-72" data-mp="1rgir4rt9p175">
                <MapPin className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-73" data-mp="3oczo179lsb4g" />
                <a href="https://www.google.com/maps/search/?api=1&query=329+NE+3rd+Ave+Cape+Coral+FL+33909" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-74" data-mp="3tb9l5new1lsp">
                  329 NE 3rd Ave
                  <br data-id="element-75" data-mp="21nbo5w4okomy" />
                  Cape Coral, FL 33909
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" data-id="element-76" data-mp="1wpjuoxoe0ugn">
                <Phone className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-77" data-mp="2tcy5ofb9vz7a" />
                <a href="tel:239-810-9482" className="hover:text-white transition-colors" data-id="element-78" data-mp="2pcnumo8miilk">
                  239-810-9482
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" data-id="element-79" data-mp="2fezwrpfq0uz6">
                <Mail className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-80" data-mp="18xuxb2wplfsu" />
                <a href="mailto:info@sinclairdevelops.com" className="hover:text-white transition-colors" data-id="element-81" data-mp="18w1njeqsufgm">
                  info@sinclairdevelops.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-82" data-mp="2woanojpd1xnu">
          <p className="text-gray-500 text-xs text-center md:text-left" data-id="element-83" data-mp="2ntw78dt3gh35">
            © {new Date().getFullYear()} Sinclair Development. All rights
            reserved.
            <span className="mx-2 text-white/20" data-id="element-84" data-mp="3bhm3pdybve68">|</span>
            <span className="text-[#C5A55A] tracking-wider" data-id="element-85" data-mp="3fkai015t9dal">
              FL License #CGC1541661
            </span>
          </p>
          <div className="flex items-center gap-4" data-id="element-86" data-mp="31lasysedywdw">
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-87" data-mp="36k43cbydm79u">
              <Facebook className="w-4 h-4" data-id="element-88" data-mp="1q4sukmr8ajom" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-89" data-mp="1v603ip53xowv">
              <Twitter className="w-4 h-4" data-id="element-90" data-mp="1nkmoo9j20j5f" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-91" data-mp="1in4ob7j3rc91">
              <Linkedin className="w-4 h-4" data-id="element-92" data-mp="1wlcjpb0hq5i3" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-93" data-mp="1rnsu5eyce6au">
              <Instagram className="w-4 h-4" data-id="element-94" data-mp="13z05m3k1v0q9" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}